import { render } from "./IniziaRilevazione.vue?vue&type=template&id=55656aea&scoped=true"
import script from "./IniziaRilevazione.vue?vue&type=script&lang=js"
export * from "./IniziaRilevazione.vue?vue&type=script&lang=js"

import "./IniziaRilevazione.vue?vue&type=style&index=0&id=55656aea&lang=scss&scoped=true"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55656aea"]])

export default __exports__